import React from "react";
import * as RTooltip from "@radix-ui/react-tooltip";
import {cn} from "../../utils/cn";

export function TooltipProvider({children, delayDuration = 200}) {
  return <RTooltip.Provider delayDuration={delayDuration}>{children}</RTooltip.Provider>;
}

export default function Tooltip({content, children, side = "top", align = "center", className, asChild = true}) {
  if (!content) return children;
  return (
    <RTooltip.Root>
      <RTooltip.Trigger asChild={asChild}>{children}</RTooltip.Trigger>
      <RTooltip.Portal>
        <RTooltip.Content
          side={side}
          align={align}
          sideOffset={4}
          className={cn(
            "z-tooltip px-2 py-1 rounded shadow-md",
            "bg-ink-900 text-white text-xs font-medium",
            "data-[state=delayed-open]:animate-fade-in",
            className
          )}
        >
          {content}
          <RTooltip.Arrow className="fill-ink-900" />
        </RTooltip.Content>
      </RTooltip.Portal>
    </RTooltip.Root>
  );
}
